'use client';

import { usePathname } from 'next/navigation';
import { useEffect, useLayoutEffect } from 'react';

import {
  installRouteChangeNotifyScheduler,
  releaseNotifyHoldOnRouteCommit,
} from '@/lib/sdk/route-change-notify-hold';

/** Releases held cache notifications in the commit that shows the new route. */
export function RouteChangeNotifyHold(): null {
  const pathname = usePathname();
  useEffect(installRouteChangeNotifyScheduler, []);
  useLayoutEffect(() => {
    releaseNotifyHoldOnRouteCommit(pathname);
  }, [pathname]);
  return null;
}
